export default __webpack_public_path__ + "static/media/windfarm.13596622.jpg";